import React from 'react';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import RichText from '../controls/RichText';
import { useForceUpdate, numberToLetter } from '../util';
import { Content, Component } from '../DataStructures';
import { TabContextReporter } from '../TabContext';
import { contentIsEmpty } from './TaskMultiChoice';
import { FormValidityReporter } from '../FormValidity';
import NumericInput from 'react-numeric-input';
import NeutralToggle from '../controls/NeutralToggle';
function atLeastOneCorrect(responses) {
  for (let i = 0; i < responses.length; i++) {
    if (responses[i].correct) {
      return true;
    }
  }
  return false;
}
export default function TaskSorting(props) {
  const forceUpdate = useForceUpdate();
  const dataProps = props.data.props;
  // console.log("TaskSorting", props.data)
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabContextReporter, {
    index: "0",
    title: "1. Initial Information"
  }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Question Prompt:"), " ", /*#__PURE__*/React.createElement("i", null, "Restate the question.")), /*#__PURE__*/React.createElement(RichText, {
    value: dataProps.prompt,
    onChange: v => {
      dataProps.prompt = v;
      forceUpdate();
      props.onChanged();
    }
  }), /*#__PURE__*/React.createElement(FormValidityReporter, {
    valid: !contentIsEmpty(dataProps.prompt)
  }, "Question Prompt is empty.")), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Number of categories:")), /*#__PURE__*/React.createElement(Form.Row, null, /*#__PURE__*/React.createElement(NumericInput, {
    min: 2,
    max: 6,
    value: dataProps.categories.length,
    onChange: e => {
      if (dataProps.categories.length > e) {
        dataProps.categories.length = e;
      } else {
        while (dataProps.categories.length < e) {
          dataProps.categories.push(new Content(`Category ${dataProps.categories.length + 1}`));
        }
      }
      forceUpdate();
      props.onChanged();
    }
  }))), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Number of options:")), /*#__PURE__*/React.createElement(Form.Row, null, /*#__PURE__*/React.createElement(NumericInput, {
    min: 2,
    max: 7,
    value: props.data.children.length,
    onChange: e => {
      if (props.data.children.length > e) {
        props.data.children.length = e;
      } else {
        while (props.data.children.length < e) {
          let c = new Component({
            tagName: "TaskSorting.Option",
            props: {
              category: 0
            },
            children: new Content(`New option ${props.data.children.length + 1}`)
          });
          props.data.children.push(c);
        }
      }
      forceUpdate();
      props.onChanged();
    }
  }))), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, "Randomize Options"), /*#__PURE__*/React.createElement(Form.Row, null, /*#__PURE__*/React.createElement(NeutralToggle, {
    optionTrue: "Yes",
    optionFalse: "No",
    value: dataProps.randomize,
    onChange: v => {
      dataProps.randomize = v;
      forceUpdate();
      props.onChanged();
    }
  }))))), /*#__PURE__*/React.createElement(TabContextReporter, {
    index: "1",
    title: "2. Categories"
  }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Question Categories:"), " ", /*#__PURE__*/React.createElement("i", null, "Short text for each category.")), dataProps.categories.map((choice, key) => {
    return /*#__PURE__*/React.createElement(Form.Group, {
      id: "choice-" + key,
      name: "choices",
      key: key
    }, /*#__PURE__*/React.createElement(RichText, {
      value: dataProps.categories[key],
      inlineOnly: true,
      onChange: v => {
        dataProps.categories[key] = v;
        forceUpdate();
        props.onChanged();
      }
    }), /*#__PURE__*/React.createElement(FormValidityReporter, {
      valid: !contentIsEmpty(dataProps.categories[key])
    }, "Category text is empty."));
  }))), /*#__PURE__*/React.createElement(TabContextReporter, {
    index: "2",
    title: "3. Options"
  }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Question Options:"), " ", /*#__PURE__*/React.createElement("i", null, "Content inside the option card.")), props.data.children.map((choice, key) => {
    return /*#__PURE__*/React.createElement(Form.Group, {
      id: "choice-" + key,
      name: "choices",
      key: key
    }, /*#__PURE__*/React.createElement(Button, {
      block: true,
      variant: "primary",
      onClick: () => {
        let fullPath = props.path.slice();
        fullPath.push("children", key, "children");
        props.scopeToItem(fullPath);
      }
    }, "Edit Content"), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Category:")), /*#__PURE__*/React.createElement(Form.Row, null, /*#__PURE__*/React.createElement(DropdownButton, {
      title: dataProps.categories[props.data.children[key].props.category]
    }, dataProps.categories.map((v, k) => {
      return /*#__PURE__*/React.createElement(Dropdown.Item, {
        key: k,
        onClick: () => {
          props.data.children[key].props.category = k;
          forceUpdate();
          props.onChanged();
        }
      }, v);
    })))));
  }))), /*#__PURE__*/React.createElement(TabContextReporter, {
    index: "3",
    title: "4. Feedback"
  }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Correct Feedback:")), /*#__PURE__*/React.createElement(RichText, {
    key: "multiselect-correct",
    value: dataProps.feedbackCorrect,
    onChange: v => {
      dataProps.feedbackCorrect = v;
      forceUpdate();
      props.onChanged();
    }
  })), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Incorrect Feedback:")), /*#__PURE__*/React.createElement(RichText, {
    key: "multiselect-incorrect",
    value: dataProps.feedbackIncorrect,
    onChange: v => {
      dataProps.feedbackIncorrect = v;
      forceUpdate();
      props.onChanged();
    }
  }))));
}